<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-10">
          <h1 class="mt-5">My Interactives</h1>
          <div *ngIf="loadingData">
            <i class="fas fa-spinner fa-pulse"></i> Loading Interactives, Please
            Wait...
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-3 mainLabel">Name</div>
        <div class="col-md-3 mainLabel">Description</div>
        <div class="col-md-2 mainLabel">Created By</div>
        <div class="col-md-4 mainLabel"></div>
      </div>
      <ng-container *ngFor="let interactive of availableInteractives">
        <div class="row table-row">
          <div class="col-md-3">
            <span
              ><a href="#" (click)="interactiveView(interactive)">{{
                interactive.interactName
              }}</a></span
            >
          </div>
          <div class="col-md-3">
            <span>{{ interactive.description }}</span>
          </div>
          <div class="col-md-2"><span>Public Insight</span></div>
          <div class="col-md-4">
            <span
              ><a href="#" (click)="interactiveView(interactive)">View</a></span
            >
            <ng-container *ngIf="interactive.canCopy">
              <span>
                |
                <a href="#" (click)="interactiveCopyAndEdit(interactive)"
                  >Copy &amp; Edit</a
                ></span
              >
            </ng-container>
            <!--<ng-container *ngIf="interactive.canPreFilter">
              <span>
                |
                <a href="#" (click)="preFilteredInteractiveCreate(interactive)"
                >Create Pre-Filter</a
                ></span
              >
            </ng-container>-->
          </div>
        </div>
      </ng-container>
      <ng-container *ngFor="let interactive of availableModifiedInteractives">
        <div class="row table-row">
          <div class="col-md-3">
            <span
              ><a href="#" (click)="modifiedInteractiveView(interactive)">{{
                interactive.name
              }}</a></span
            >
          </div>
          <div class="col-md-3">
            <span>{{ interactive.interactive.description }}</span>
          </div>
          <div class="col-md-2">
            <span>{{ interactive.createdBy }}</span>
          </div>
          <div class="col-md-4">
            <span
              ><a href="#" (click)="modifiedInteractiveView(interactive)"
                >View</a
              ></span
            >
            <ng-container *ngIf="interactive.allowEdit">
              <span>
                |
                <a href="#" (click)="modifiedInteractiveEdit(interactive)"
                  >Edit</a
                ></span
              >
            </ng-container>
            <ng-container *ngIf="interactive.owner">
              <span>
                |
                <a href="#" (click)="modifiedInteractiveDelete(interactive)"
                  >Delete</a
                ></span
              >
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- <ng-container *ngFor="let interactive of availablePreFilteredInteractives">
        <div class="row table-row">
          <div class="col-md-3">
            <span
            ><a href="#" (click)="preFilterInteractiveView(interactive)">{{
              interactive.name
              }}</a></span
            >
          </div>
          <div class="col-md-3">
            <span>{{ interactive.interactive.description }}</span>
          </div>
          <div class="col-md-2">
            <span>{{ interactive.createdBy }}</span>
          </div>
          <div class="col-md-4">
            <span
            ><a href="#" (click)="preFilterInteractiveView(interactive)"
            >View</a
            ></span
            >
            <ng-container *ngIf="interactive.allowEdit">
              <span>
                |
                <a href="#" (click)="preFilterInteractiveEdit(interactive)"
                >Edit</a
                ></span
              >
            </ng-container>
            <ng-container *ngIf="interactive.owner">
              <span>
                |
                <a href="#" (click)="preFilterInteractiveDelete(interactive)"
                >Delete</a
                ></span
              >
            </ng-container>
          </div>
        </div>
      </ng-container> -->
    </mat-card-content>
  </mat-card>
</div>
